const siteSettings = {
  title: process.env.NODE_ENV === 'development' ? 'ShowsLike(dev)' : 'ShowsLike',
  description: 'Admin interface for ShowsLike.net',
  apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:5600/api' : 'https://data.showslike.net/api',
  siteUrl: 'https://showslike.net',
  showLimit: 10
}

export default siteSettings;
